import { type FC, useEffect } from "react";
import FontAwesomeLight from "../../../app/Utilities/Platform/FontAwesome/FontAwesomeLight";

interface Props {
    onLoad: () => void;
}

export const ApplicationHistoryLoad: FC<Props> = ({
    onLoad,
}) => {
    useEffect(() => {
        onLoad();
    }, [ onLoad ]);

    return (
        <div className="w-full text-center text-gray-600">
            <FontAwesomeLight
                className="mr-2"
                icon="spinner-third"
                spin
            />
            Loading More...
        </div>
    );
};
